import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { EMICalculator } from '@/components/EMICalculator';
export default function About() {
    return (
        <section className="about-section" data-testid="about-section">
            <div className="container">
                <div className="about-grid">
                    <div className="about-content">
                        <h2 className="section-title">Provide the best loan solutions with great team effort</h2>
                        <p className="about-text">
                            Laxmi Finsec Consultant Pvt. Ltd. is dealing in Women Group Loan, Shop Loan, Flat Loan, Personal Loan,
                            Home Loan Agriculture Loan, Plot Loan, Complex loan, Sale-Purchase Loan, Project Loan, Education Loan,
                            Pay Slip Loan, Gold Loan, Insurance, Policy Bond Loan, Car Loan, Machine Loan, Business Loans,
                            Loan Against Property & Project Etc.
                        </p>
                        <p className="about-text">
                            We believe in fair dealing and prompt dispersement of funds on priority Basis. We are dealing all India
                            Business and Serve to owner client at a very reasonable cost. Laxmi Finsec Consultant Pvt. Ltd. is authorized
                            and process with all necessary Certificates.
                        </p>
                        <Link to="/about">
                            <Button className="about-btn" data-testid="about-learn-more">Learn More</Button>
                        </Link>
                    </div>
                    <EMICalculator />
                </div>
            </div>
        </section>
    );
};
